export const ArrowLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 125"
      fill={"#fff"}
    >
      <polygon points="75.3,99.3 74.7,100 24.7,50 74.7,0 75.3,0.7 75.3,22.6 48,50 75.3,77.4 " />
    </svg>
  );
};
